import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import ImageComponent from 'atoms/Image/index';
import { Row, Col } from 'reactstrap';
import { InputBox } from 'atoms/InputBox';
import NavigationItems from './NavigationItems';
import StaticBrandPage from 'organisms/BrandPage/Presentation/StaticBrandPage';
import SearchItems from './SearchItems';
import {
  getCategoryAndProduct,
  closeSearchFilterMenu,
  changeMenulistOrder,
} from '../NutritionAllergenUtilities/NutritionAllergenUtils';
import NUTRITION_ALLERGEN_CONSTANTS, {
  ENTER,
  YOUR_SEARCH_TEXT,
  RETURNED_NO_RESULTS,
  NUTRITION_ALLERGEN_GUIDE,
  STATIC_BRAND_PAGE,
  NUTRITION_ALLERGEN_GUIDE_BOTTOM,
} from '../NutritionAllergenConstants/NutritionAllergenConstants';
import {
  filterNotHiddenProducts,
  isEmptyObject,
  getValueOrDefaultObject,
  getTernaryValue,
  getAndCheck,
} from 'common/utilities/utils';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { getMenusSubcategory, hasSubcategory } from '../NutritionAllergenUtilities/NutritionAllergenSharedUtils';
import MobSearchFilterMenu from './MobSearchFilterMenu';
import NutrationAllergenItems from './NutritionAllergenItems';
import SEARCH_STORE_CONSTANTS from 'organisms/SearchStore/AU/Constants/SearchStoreConstants';

import getNutritionAllergenDisclaimer from '@kfc-global/react-shared/redux/Actions/NutritionAllergenDisclaimerAction';
import { getCmsClient } from 'common/utilities/cmsClient';
import { get } from 'lodash';
import { ROUTE_URL, ACTIVITY_EVENTS } from 'common/constants/SharedConstants';
import NutritionAllergenAccordian from './NutritionAllergenAccordian';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import { checkItemName } from 'organisms/MenusPLP/AU/MenusPlpUtilities/MenusPlpUtils';
import STYLE_SCRIPT_CONST from 'common/style-scripts/constants';
import useStyleScripts from 'common/custom-hooks/useStyleScripts';

export const staticNutrionBrandPage = nutritionAllergenDisclaimerContent => {
  if (isEmptyObject(nutritionAllergenDisclaimerContent)) {
    const segmentednutritionAllergenStaticBrandPage =
      nutritionAllergenDisclaimerContent?.nutritionAllergenDisclaimerResp?.items[0]?.fields?.content;
    const staticBrandPageData = segmentednutritionAllergenStaticBrandPage?.filter(
      item => item?.sys?.contentType?.sys?.id === STATIC_BRAND_PAGE,
    );
    return staticBrandPageData?.map(item => {
      return <StaticBrandPage data={item.fields} />;
    });
  }
  return null;
};

const CompactNutritionAllergen = ({
  data,
  selectedTile,
  tenantData,
  filterList = [],
  handleClearItems,
  handleFilteredData,
  handleSearchdata,
  tempData = {},
  catalogs,
  selectedCat,
  setProductId,
  isMobile,
  showSmartBannerVisible,
}) => {
  let { menu, categories, products } = getValueOrDefaultObject(data);
  if (Object.keys(tempData)?.length) {
    ({ menu, categories, products } = tempData);
  }
  const [hideTopRow, setHideTopRow] = useState(false);
  const mobileSearchFilterMenuRef = useRef();
  const history = useHistory();
  const [viewCarousal,] = useState(false);
  const [viewUp,] = useState(true);
  const [isSmartBannerVisible, setIsSmartBannerVisible] = useState(showSmartBannerVisible ?? true);
  const [categoryStatus, setCategoryStatus] = useState(false);
  const [paramValue, setParamValue] = useState(false);
  const [activeMenuSelection, setActiveMenuSelection] = useState('');
  const [inputSearchOpen, setInputSearchOpen] = useState(false);
  const [suggestedData, setsuggestedData] = useState([]);
  const [inputSearchValue, setInputSearchValue] = useState('');
  const filterRef = useRef(null);
  const [searchMode, setSearchMode] = useState({ isSearchedMode: false, searchedData: '' });
  const { localized } = useSelector(data => data.appStateReducer?.userStatus);
  const {
    SEARCHOURMENU,
    KFC_MENU_TITLE,
    NUTRITION_ALLERGEN_ACTION_RESPONSE,
    PERCENT_DAILY_VALUES_TEXT,
    INFORMATION_CORRECT_TEXT,
  } = NUTRITION_ALLERGEN_CONSTANTS;

  const { category_name = '', product_name = '' } = useParams();

  const dispatch = useDispatch();
  const CustomStyledCol = useStyleScripts(STYLE_SCRIPT_CONST?.MENU_CATEGORY_STYLES_DESKTOP, Col);
  const CustomStyledRow = useStyleScripts(STYLE_SCRIPT_CONST?.MENU_CATEGORY_STYLES_MOBILE, Row);

  useEffect(() => {
    dispatch(
      getNutritionAllergenDisclaimer({
        object: getCmsClient(),
        contentFull: {
          content_type: 'supportContent',
          include: '5',
          'fields.title': 'NutritionAllergen',
        },
      }),
    );
  }, [dispatch]);

  let segmentednutritionAllergenDisclaimer = null;

  const allReducerData = useSelector(data => {
    return {
      nutritionAllergenDisclaimerContent: get(data, NUTRITION_ALLERGEN_ACTION_RESPONSE, null),
    };
  });
  if (isEmptyObject(allReducerData?.nutritionAllergenDisclaimerContent)) {
    segmentednutritionAllergenDisclaimer =
      allReducerData?.nutritionAllergenDisclaimerContent?.nutritionAllergenDisclaimerResp?.items[0]?.fields?.content;
  }

  useEffect(() => {
    // Bind the event listener
    document.addEventListener(ACTIVITY_EVENTS[0], handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener(ACTIVITY_EVENTS[0], handleClickOutside);
    };
  });

  useEffect(() => {
    const updatedCategories = changeMenulistOrder(categories);
    getCategoryAndProduct(
      updatedCategories,
      category_name,
      product_name,
      setProductId,
      setParamValue,
      setCategoryStatus,
      isMobile,
    );
    // eslint-disable-next-line
  }, []);

  //mobile methods

  const handleSetActive = useCallback(
    (param, id) => {
      setActiveMenuSelection(() => param);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isMobile],
  );

  const openSearchFilterMenu = () => {
    mobileSearchFilterMenuRef.current.style.width = '100%'; // show filter modal
    setHideTopRow(true);
  };
  const setSearchModeSet = (flag, val) => {
    setSearchMode({ isSearchedMode: flag, searchedData: val });
  };

  const scrollEventListener = () => {
    const kfcBannerImage = document?.getElementById(NUTRITION_ALLERGEN_GUIDE);
    const bounding = kfcBannerImage?.getBoundingClientRect();
    setIsSmartBannerVisible(bounding?.bottom > NUTRITION_ALLERGEN_GUIDE_BOTTOM);
  };
  useEffect(() => {
    window.addEventListener('scroll', scrollEventListener);
    return () => window.removeEventListener('scroll', scrollEventListener);
  }, [isMobile]);

  //desktop methods

  const handleClickOutside = event => {
    if (filterRef.current && !filterRef.current.contains(event.target)) {
      setInputSearchOpen(false);
    }
  };

  const hasSubcategoryMemoized = useCallback(subCategory => {
    hasSubcategory(subCategory);
  }, []);

  const onItemClick = useCallback(
    (event, subCategoryName, url, index) => {
      setActiveMenuSelection(() => subCategoryName);
      const element = event?.target.parentElement.querySelector('.nested');
      if (element) {
        element.classList.toggle('active-tree');
        if (event.target.classList) {
          event.target.classList.toggle('caret-down');
        }
      }
      history.push({
        pathname: `${ROUTE_URL.NUTRITION_ALLERGEN}/${url}`,
      });
    },
    [history],
  );

  const getMenusSubcategoryMemoized = useCallback(
    (category, Link) => {
      getMenusSubcategory(category, Link, handleSetActive, onItemClick);
    },
    [handleSetActive, onItemClick],
  );

  const filteredMenu = useCallback(
    val => {
      if (products?.length > 0) {
        setsuggestedData(
          products?.filter(obj => getAndCheck(!obj.isHidden, checkItemName(obj?.name, val))).slice(0, 5),
        );
      }
    },
    [products],
  );

  const clearSearch = useCallback(() => {
    setInputSearchValue('');
    setInputSearchOpen(false);
    filteredMenu('');
    handleSearchdata();
    setSearchMode({ isSearchedMode: false, searchedData: '' });
  }, [filteredMenu, handleSearchdata]);

  const filteredData = item => {
    handleFilteredData(item.mdmId);
    setInputSearchOpen(false);
    setInputSearchValue(item.name);
    setSearchMode({ isSearchedMode: true, searchedData: item.name });
    window.scrollTo(0, 0);
  };

  const handleKeyPress = event => {
    if (event.key === ENTER) {
      if (event.target.value === '') {
        return;
      }
      setInputSearchOpen(false);
      handleSearchdata(event.target.value.toLowerCase().toString());
      setSearchMode({ isSearchedMode: true, searchedData: inputSearchValue });
      window.scrollTo(0, 0);
    }
  };

  const handleInput = e => {
    setInputSearchValue(e.target.value);
    if (filterList.length) {
      handleClearItems();
    }
    /* istanbul ignore next */
    if (e.target.value.toString().length > 2) {
      setInputSearchOpen(true);
      filteredMenu(e.target.value.toString());
    } else {
      if (inputSearchOpen) {
        /* istanbul ignore next */
        setInputSearchOpen(false);
        filteredMenu('');
        handleSearchdata();
        setSearchMode({ isSearchedMode: false, searchedData: '' });
      }
    }
  };

  //Reusable Items
  const closeSearchFilterMenuMemoized = useCallback(() => {
    closeSearchFilterMenu(filterList, mobileSearchFilterMenuRef, setHideTopRow);
  }, [filterList]);

  const noSearchResult = (
    <div className='no-search-results-found'>
      <span>{translateWithI18Next(YOUR_SEARCH_TEXT)}</span>
      <span> "{inputSearchValue}" </span>
      <div>
        <span>{translateWithI18Next(RETURNED_NO_RESULTS)}</span>
      </div>
    </div>
  );
  return (
    <React.Fragment>
      {isMobile ? (
        <div className='mob-plp-au-nutrition'>
          {CustomStyledRow && (
            <CustomStyledRow
              id='mob-searchinput-id'
              data-testid='mob-searchinput-id'
              isSmartBannerVisible={isSmartBannerVisible}
              topGuideValue={document?.getElementById('header-container')?.clientHeight}
              topValue={document?.getElementById('select-start-order-items')?.clientHeight}
              className={`mob-nav-row ${getTernaryValue(hideTopRow, 'hide-mob-nav-row', '')}${getTernaryValue(
                localized,
                'localized',
                'nonLocalizeGuide',
              )} ${getAndCheck(window.location.href.includes('true'), 'rnaNutritionAllergen-header')}`}
            >
              <div onClick={() => openSearchFilterMenu()} data-testid='open-search-menu' className='mob-search-input'>
                <ImageComponent srcFile={IMAGE_PATH.MobSearchIcon} className='mob-search-img' alt='' />
                {searchMode.isSearchedMode && (
                  <div className='totalFilterAppliedCount'>{filterNotHiddenProducts(products)}</div>
                )}
              </div>
              <NavigationItems
                filterList={filterList}
                searchMode={searchMode}
                isMobile={isMobile}
                clearSearch={clearSearch}
                handleClearItems={handleClearItems}
                menu={menu}
                categories={categories}
                setActiveMenuSelection={setActiveMenuSelection}
                history={history}
                hasSubcategory={hasSubcategoryMemoized}
                handleSetActive={handleSetActive}
                getMenusSubcategory={getMenusSubcategoryMemoized}
                onItemClick={/* istanbul ignore next */ onItemClick}
              />
            </CustomStyledRow>
          )}
          <SearchItems searchMode={searchMode} filterList={filterList} isMobile={isMobile} products={products} />
          <Row className='mob-plp-sections'>
            <div className='percent-daily-text-mobile' style={{ padding: '15px' }}>
              <div> {translateWithI18Next(PERCENT_DAILY_VALUES_TEXT)}</div>
              <div>{translateWithI18Next(INFORMATION_CORRECT_TEXT)}</div>
            </div>
          </Row>
          <Row className='mob-plp-sections'>
            <NutrationAllergenItems
              isMobile={isMobile}
              searchMode={searchMode}
              categories={categories}
              viewUp={viewUp}
              tenantData={tenantData}
              localized={localized}
              catalogs={catalogs}
              selectedCat={selectedCat}
              filterList={filterList}
              products={products}
              clearSearch={clearSearch}
            />
          </Row>
          <NutritionAllergenAccordian NutritionAllergenInfo={segmentednutritionAllergenDisclaimer} />
          {staticNutrionBrandPage(allReducerData?.nutritionAllergenDisclaimerContent)}
          <MobSearchFilterMenu
            ref={mobileSearchFilterMenuRef}
            className='sidenav-filter'
            selectedTile={selectedTile}
            filterList={filterList}
            handleClearItems={handleClearItems}
            closeSearchFilterMenu={closeSearchFilterMenuMemoized}
            tempData={tempData}
            data={data}
            inputSearchData={inputSearchValue}
            handleFilteredData={handleFilteredData}
            handleSearchdata={handleSearchdata}
            setSearchModeData={setSearchModeSet}
          />
        </div>
      ) : (
        <Row className='plp-menu-row' data-testid='menus-container'>
          {CustomStyledCol && (
            <CustomStyledCol md='3' className={`plp-left-nav plp-side-panel${(localized && ' localized' ) || ''}`}>
              <Row className='plp-stripes-section'>
                <ImageComponent srcFile={IMAGE_PATH.StripesIcon} className='stripes-img' alt='' />
              </Row>
              <h1 className='kfc-menu-title'>
                {(([...filterList].length || searchMode.isSearchedMode
                 ) && `${filterNotHiddenProducts(products)} Results`
                  ) || translateWithI18Next(KFC_MENU_TITLE)}
              </h1>
              <NavigationItems
                filterList={filterList}
                searchMode={searchMode}
                isMobile={isMobile}
                clearSearch={clearSearch}
                handleClearItems={handleClearItems}
                menu={menu}
                categories={categories}
                setActiveMenuSelection={setActiveMenuSelection}
                history={history}
                hasSubcategory={hasSubcategoryMemoized}
                handleSetActive={handleSetActive}
                getMenusSubcategory={getMenusSubcategoryMemoized}
              />
            </CustomStyledCol>
          )}
          <Col md='9' className='plp-right-nav nutration-allergen-right-nav'>
            <Col sm={12} className='plp-filters' style={{ width: '100%' }}>
              <div data-testid='menu-search-testid' className='search-menu'>
                <InputBox
                  name='searchInput'
                  className='search-menu-input'
                  onKeyPress={e => handleKeyPress(e)}
                  onChange={e => handleInput(e)}
                  value={inputSearchValue}
                  placeholder={translateWithI18Next(SEARCHOURMENU)}
                  aria-label='Search our menu'
                  autocomplete='off'
                  onBlur={event => (event.target.placeholder = `${translateWithI18Next(SEARCHOURMENU)}`)}
                />
                <span className='search-icon'>
                  <ImageComponent srcFile={IMAGE_PATH.SearchIcon} className='search-icon-img' alt='' />
                </span>
                {(((inputSearchValue.length > 2 && !searchMode.isSearchedMode) ||
                (inputSearchValue.length > 2 && searchMode.isSearchedMode && filterNotHiddenProducts(products) > 0)) && (
                  <img
                    className='input-dark-cross'
                    data-testid='clear-all-input'
                    onClick={() => clearSearch()}
                    src={IMAGE_PATH.DarkCloseButton}
                    alt=''
                  />
                ))}
                {inputSearchOpen && (
                  <div ref={filterRef} className='inputAutoCompletePLP'>
                    {(suggestedData?.length > 0 && (
                      <div>
                        <div className='SuggestionHeader'>
                          {' '}
                          {translateWithI18Next(SEARCH_STORE_CONSTANTS.SUUGESTED_ITEMS_TEXT)}
                        </div>
                        <ul className='autoCompleteListPLP'>
                          {suggestedData.map((item, index) => (
                            <li
                              onClick={() => filteredData(item)}
                              key={item.mdmId + index}
                              data-testid={`suggestion-click-${item.name}`}
                              className='wrapperAutoCompletePLP'
                            >
                              <span className='searchgrey-icon-img'>
                                <ImageComponent srcFile={IMAGE_PATH.Polygon} alt='' />
                              </span>
                              <span>{item.dname?.[0]?.value}</span>
                            </li>
                          ))}
                        </ul>
                      </div>
                    )) || (
                      noSearchResult
                    )}
                  </div>
                )}
              </div>
            </Col>
            <SearchItems searchMode={searchMode} filterList={filterList} isMobile={isMobile} products={products} />
            <div
              className='percent-daily-text'
              style={{ display: 'flex', justifyContent: 'space-between', marginTop: '26px' }}
            >
              <div>{translateWithI18Next(PERCENT_DAILY_VALUES_TEXT)}</div>
              <div>{translateWithI18Next(INFORMATION_CORRECT_TEXT)}</div>
            </div>
            <Row className={(searchMode.isSearchedMode && '' ) || 'plp-sections'}>
              <NutrationAllergenItems
                isMobile={isMobile}
                searchMode={searchMode}
                categories={categories}
                viewCarousal={viewCarousal}
                viewUp={viewUp}
                tenantData={tenantData}
                catalogs={catalogs}
                filterList={filterList}
                products={products}
                clearSearch={clearSearch}
                localized={localized}
              />
            </Row>
            <NutritionAllergenAccordian NutritionAllergenInfo={segmentednutritionAllergenDisclaimer} />
            {staticNutrionBrandPage(allReducerData?.nutritionAllergenDisclaimerContent)}
          </Col>
        </Row>
      )}
    </React.Fragment>
  );
};

export const CompactNutritionAllergenItem = React.memo(CompactNutritionAllergen);
